/*
  Delivery estimate
  -----------------
  Single source of truth for the "expected delivery" date range shown in:
    - the cart drawer            -> #delivery-estimate (+3 business days if an engraving line is in the cart)
    - the product page buy box   -> [data-delivery-estimate] inside [data-ship-estimate]

  Range = the 1st and 3rd business day after today (weekends skipped; a weekend
  "today" rolls to Monday first). When engraving is selected on the product
  page the whole range shifts by ENGRAVING_EXTRA_DAYS business days.
*/
(function () {
  var ENGRAVING_EXTRA_DAYS = 3;
  var ENGRAVING_HANDLE = 'engraving-personalisation';

  function getNextBusinessDays(startDate, count) {
    var result = [];
    var date = new Date(startDate);

    // If today is Saturday (6) or Sunday (0), start from next Monday
    while (date.getDay() === 0 || date.getDay() === 6) {
      date.setDate(date.getDate() + 1);
    }

    while (result.length < count) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) {
        result.push(new Date(date));
      }
    }
    return result;
  }

  function formatDate(date) {
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    return day + '/' + month;
  }

  function getDeliveryRange(extraBusinessDays) {
    var extra = extraBusinessDays || 0;
    var days = getNextBusinessDays(new Date(), 3 + extra);
    return formatDate(days[extra]) + ' - ' + formatDate(days[extra + 2]);
  }

  function engravingActive() {
    return !!(window.EngravingCheck && window.EngravingCheck.isActive());
  }

  // Cart drawer: +3 business days when an engraving line is in the cart.
  // The drawer re-renders its markup on every cart change, so we read the
  // current line items from the DOM (engraving product link) each time.
  // A data-extra-days attribute on #delivery-estimate, if ever added, wins.
  function cartExtraDays(cartEl) {
    var forced = parseInt(cartEl.getAttribute('data-extra-days'), 10);
    if (!isNaN(forced)) return forced;
    var scope = document.getElementById('CartDrawer') || document;
    var sel = 'a[href*="/products/' + ENGRAVING_HANDLE + '"]';
    return scope.querySelector(sel) ? ENGRAVING_EXTRA_DAYS : 0;
  }

  function updateDeliveryEstimate() {
    // Cart drawer
    var cartEl = document.getElementById('delivery-estimate');
    if (cartEl) cartEl.textContent = getDeliveryRange(cartExtraDays(cartEl));

    // Product page buy box (+3 business days while engraving is selected)
    var extra = engravingActive() ? ENGRAVING_EXTRA_DAYS : 0;
    document.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
      el.textContent = getDeliveryRange(extra);
    });
  }

  // Hide the "Ready To Ship" line while the selected variant is sold out.
  function isSoldOutButton(btn) {
    if (!btn || !btn.hasAttribute('disabled')) return false;
    var label = btn.querySelector('span');
    var soldOut = window.variantStrings && window.variantStrings.soldOut;
    return !!(label && soldOut && label.textContent.trim() === soldOut);
  }

  function syncShipEstimateVisibility() {
    document.querySelectorAll('[data-ship-estimate]').forEach(function (box) {
      var form = box.closest('form');
      var btn = form ? form.querySelector('button[name="add"]') : null;
      box.classList.toggle('hidden', isSoldOutButton(btn));
    });
  }

  function init() {
    updateDeliveryEstimate();
    syncShipEstimateVisibility();

    // Engraving toggle: snippets/engraving-customization.liquid flips the
    // "is-on" class on #engraving (on click and when a variant without
    // engraving is selected). Watch that class so the dates follow it.
    var engRoot = document.getElementById('engraving');
    if (engRoot && 'MutationObserver' in window) {
      new MutationObserver(updateDeliveryEstimate).observe(engRoot, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    document.querySelectorAll('[data-ship-estimate]').forEach(function (box) {
      var form = box.closest('form');
      var btn = form ? form.querySelector('button[name="add"]') : null;
      if (!btn || !('MutationObserver' in window)) return;
      new MutationObserver(syncShipEstimateVisibility).observe(btn, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  }

  window.updateDeliveryEstimate = updateDeliveryEstimate;

  // Optional hook for other scripts
  document.addEventListener('engraving:toggle', updateDeliveryEstimate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-render whenever the cart changes (cart drawer re-renders its markup)
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Skip if event source is 'cart-items' since that might be handled elsewhere
      if (event && event.source === 'cart-items') return;
      updateDeliveryEstimate();
    });
  }
})();
